import { Component } from 'react'
import BaseState from './BaseState';

import SessionHelper from './SessionHelper';
 
import BasePageProps from './BasePageProps'
import ConstantMessage from './ConstantMessage';


export default abstract class BaseComponentCore<T extends BasePageProps, U> extends Component<T, BaseState<U>> {

  ViewModel: any = undefined;
  constructor(props: T) {
    super(props)
    //TODO:open when api integrate done
    //TODO:After new theme migration open
    this.HandleAuthentication(props);
    //this.state= new BaseState<A>(new U());
    //this.state= {};
  }

  // componentDidMount(){
  // this.HandleAuthentication(this.props);
  // }

  HandleAuthentication(props: T) {
    var user = SessionHelper.GetSession();

    // @ts-ignore: Unreachable code error
    if (user === null && this.props.location && this.props.location.pathname !== ConstantMessage.LoginPagePath) {
      this.props?.history?.push(ConstantMessage.LoginPagePath);
    }

  }


  SetModelValue = (event: any) => {

    if (!event) {
      return
    }

    const { target: { id, name, value } } = event;
    var propertyName = id;
    if (!propertyName) {
      propertyName = name;
    }


    Object.assign(this.state.Model, { [propertyName]: value })
    //console.log(this.state.Model)
    this.setState({
      Model: this.state.Model
    } as Pick<BaseState<U>, keyof BaseState<U>>);
  }

  UpdateViewModelUnknown(model: any) {
    this.setState({
      Model: model as unknown as U
    })
  }
  UpdateViewModel() {
    this.setState({
      Model: this.state.Model
    })
  }

}

